import { sendLedsToStellaBIO } from ".";
import * as blend from "color-blend";

interface AnimationData {
    time: number;
    states: number;
    loop: boolean;
    stateLoop: boolean;
    interpolateLastFirst: number;
    layers: {
        enabled: boolean;
        func: ((progress: number, diode: number, state: number, nextState: number, layer: number) => number) | null;
        color: number;
    }[]
}

const loadingAnimation: AnimationData = {
    time: 1000,
    states: 8,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 0,
    layers: [
        {
            enabled: true,
            func: loading,
            color: 0xFFFFFF
        },
        {
            enabled: false,
            func: null,
            color: 0
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const spinAnimation: AnimationData = {
    time: 1000,
    states: 1,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 1,
    layers: [
        {
            enabled: true,
            func: spin,
            color: 0xFFFFFF
        },
        {
            enabled: false,
            func: null,
            color: 0
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const smootherSpinAnimation: AnimationData = {
    time: 1000,
    states: 1,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 2,
    layers: [
        {
            enabled: true,
            func: smootherSpin,
            color: 0xFFFFFF
        },
        {
            enabled: false,
            func: null,
            color: 0
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const twoColorSpinAnimation: AnimationData = {
    time: 1000,
    states: 1,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 2,
    layers: [
        {
            enabled: true,
            func: fixed0p5,
            color: 0x0000FF
        },
        {
            enabled: true,
            func: smootherSpin,
            color: 0xFFFFFF
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const transitionAnimation: AnimationData = {
    time: 1000,
    states: 1,
    loop: false,
    stateLoop: false,
    interpolateLastFirst: 0,
    layers: [
        {
            enabled: true,
            func: fixed0p5,
            color: 0xFF0000
        },
        {
            enabled: true,
            func: fill,
            color: 0x00FF00
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const turnOnSpinAnimation: AnimationData = {
    time: 1000,
    states: 1,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 0,
    layers: [
        {
            enabled: true,
            func: fixed1p0,
            color: 0
        },
        {
            enabled: true,
            func: turnOn,
            color: 0xFFFFFF
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const gradientAnimation: AnimationData = {
    time: 1000,
    states: 1,
    loop: false,
    stateLoop: false,
    interpolateLastFirst: 0,
    layers: [
        {
            enabled: true,
            func: gradient,
            color: 0xFF0000
        },
        {
            enabled: true,
            func: gradient,
            color: 0x0000FF
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const gradient3ColorsAnimation: AnimationData = {
    time: 2000,
    states: 1,
    loop: false,
    stateLoop: false,
    interpolateLastFirst: 0,
    layers: [
        {
            enabled: true,
            func: gradient3Colors,
            color: 0xFF0000
        },
        {
            enabled: true,
            func: gradient3Colors,
            color: 0x0000FF
        },
        {
            enabled: true,
            func: gradient3Colors,
            color: 0x00FF00
        }
    ]
};

const flowingAnimation: AnimationData = {
    time: 2000,
    states: 1,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 0,
    layers: [
        {
            enabled: true,
            func: fixed1p0,
            color: 0x0a1852
        },
        {
            enabled: true,
            func: flowing,
            color: 0x66cccc
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const wifiBadPasswordAnimation: AnimationData = {
    time: 2000,
    states: 1,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 2,
    layers: [
        {
            enabled: true,
            func: smootherSpinWithDot,
            color: 0x753900
        },
        {
            enabled: true,
            func: smootherSpinWithDot,
            color: 0xFFFFFF
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};


const wifiConnectedAnimation: AnimationData = {
    time: 2000,
    states: 1,
    loop: false,
    stateLoop: false,
    interpolateLastFirst: 2,
    layers: [
        {
            enabled: true,
            func: wifiConnected,
            color: 0xFFFFFF
        },
        {
            enabled: false,
            func: null,
            color: 0
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const standByNoAppAnimation: AnimationData = {
    time: 2000,
    states: 1,
    loop: false,
    stateLoop: false,
    interpolateLastFirst: 2,
    layers: [
        {
            enabled: true,
            func: fixed1p0,
            color: 0xffffff
        },
        {
            enabled: false,
            func: null,
            color: 0
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const appConnectedAnimation: AnimationData = {
    time: 1000,
    states: 1,
    loop: false,
    stateLoop: false,
    interpolateLastFirst: 0,
    layers: [
        {
            enabled: true,
            func: gradient,
            color: 0xffffff
        },
        {
            enabled: true,
            func: gradient,
            color: 0x0a1852
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};


const standByAnimation: AnimationData = {
    time: 2000,
    states: 1,
    loop: false,
    stateLoop: false,
    interpolateLastFirst: 2,
    layers: [
        {
            enabled: true,
            func: fixed1p0,
            color: 0x0a1852
        },
        {
            enabled: false,
            func: null,
            color: 0
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const appDisconnectedAnimation: AnimationData = {
    time: 1000,
    states: 1,
    loop: false,
    stateLoop: false,
    interpolateLastFirst: 0,
    layers: [
        {
            enabled: true,
            func: gradient,
            color: 0x0a1852
        },
        {
            enabled: true,
            func: gradient,
            color: 0xffffff
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};

const electrostimLowBatteryAnimation: AnimationData = {
    time: 2000,
    states: 1,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 0,
    layers: [
        {
            enabled: true,
            func: fixed1p0,
            color: 0x0a1852
        },
        {
            enabled: true,
            func: slowBlink,
            color: 0x753900
        },
        {
            enabled: true,
            func: flowing,
            color: 0x66cccc
        }
    ]
};

const warningAnimation: AnimationData = {
    time: 2000,
    states: 1,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 2,
    layers: [
        {
            enabled: true,
            func: warning,
            color: 0x753900
        },
        {
            enabled: false,
            func: null,
            color: 0
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};


const errorAnimation: AnimationData = {
    time: 2000,
    states: 1,
    loop: false,
    stateLoop: true,
    interpolateLastFirst: 2,
    layers: [
        {
            enabled: true,
            func: warning,
            color: 0xff0000
        },
        {
            enabled: false,
            func: null,
            color: 0
        },
        {
            enabled: false,
            func: null,
            color: 0
        }
    ]
};



export const animationMap: { [key: string]: AnimationData } = {
    loading: loadingAnimation,
    spin: spinAnimation,
    smoothSpin: smootherSpinAnimation,
    transition: transitionAnimation,
    twoColorSpin: twoColorSpinAnimation,
    turnOn: turnOnSpinAnimation,
    gradient: gradientAnimation,
    gradient3Colors: gradient3ColorsAnimation,
    wifiConnecting: {
        ...smootherSpinAnimation,
        time: 2000
    },
    wifiBadPassword: wifiBadPasswordAnimation,
    wifiConnected: wifiConnectedAnimation,
    standByNoApp: standByNoAppAnimation,
    appConnected: appConnectedAnimation,
    standBy: standByAnimation,
    appDisconnected: appDisconnectedAnimation,
    electrostim: flowingAnimation,
    electrostimLowBattery: electrostimLowBatteryAnimation,
    warning: warningAnimation,
    error: errorAnimation
}

export function colorToArray(color: number) {
    let a = (color >> 24) & 0xff;
    let r = (color >> 16) & 0xff;
    let g = (color >> 8) & 0xff;
    let b = (color) & 0xff;

    return [r, g, b, a / 255];
}

export function arrayToColor(color: number[]) {
    return (Math.floor(color[3] * 255) << 24) | (color[0] << 16) | (color[1] << 8) | color[2];
}

export function rgbaToColor(color: { r: number, g: number, b: number, a: number }) {
    return (Math.floor(color.a * 255) << 24) | (color.r << 16) | (color.g << 8) | color.b;
}

export function colorToRgba(color: number) {
    let a = (color >> 24) & 0xff;
    let r = (color >> 16) & 0xff;
    let g = (color >> 8) & 0xff;
    let b = (color) & 0xff;

    return { r, g, b, a: a / 255 };
}


function multiplyColor(color: number, scalar: number) {
    let r = (color >> 16) & 0xff;
    let g = (color >> 8) & 0xff;
    let b = (color) & 0xff;

    r = Math.max(0, Math.min(255, Math.round(r * scalar)));
    g = Math.max(0, Math.min(255, Math.round(g * scalar)));
    b = Math.max(0, Math.min(255, Math.round(b * scalar)));

    return (Math.floor(scalar * 255) << 24) | (r << 16) | (g << 8) | b;
}

function blendColors(baseC: number, addedC: number) {
    var mix;
    const base = colorToArray(baseC);
    const added = colorToArray(addedC);

    if (typeof added[3] === 'undefined') {
        added[3] = 1;
    }

    // check if both alpha channels exist.
    if (base[3] && added[3]) {
        mix = [0, 0, 0, 0];
        // alpha
        mix[3] = 1 - (1 - added[3]) * (1 - base[3]);
        // red
        mix[0] = Math.round((added[0] * added[3] / mix[3]) + (base[0] * base[3] * (1 - added[3]) / mix[3]));
        // green
        mix[1] = Math.round((added[1] * added[3] / mix[3]) + (base[1] * base[3] * (1 - added[3]) / mix[3]));
        // blue
        mix[2] = Math.round((added[2] * added[3] / mix[3]) + (base[2] * base[3] * (1 - added[3]) / mix[3]));

    } else if (added[3]) {
        mix = added;
    } else {
        mix = base;
    }

    return arrayToColor(mix);
}


export class AnimationRunner {
    private time = 0;
    private state = 0;
    private nextState = 0;
    private queuedState = 0;
    private _animation = "loading";
    private animationData: AnimationData = loadingAnimation;

    get animation() {
        return this._animation;
    }

    set animation(value) {
        this._animation = value;

        this.animationData = animationMap[value];
        this.time = 0;
        this.state = 0;
        this.nextState = 0;
        this.queuedState = 0;
    }

    colors: [string, string, string] = ["#000000", "#000000", "#000000"];
    animationTime: number = 1000;
    overrideTime: boolean = false;
    overrideColors: [boolean, boolean, boolean] = [false, false, false];
    ledArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    start() {
        this.time = 0;
        this.state = 0;
        this.nextState = 0;
        this.queuedState = 0;
    }

    isFinished() {
        return this.state >= this.animationData.states;
    }

    run(deltaTime: number) {
        if (this.state >= this.animationData.states) {
            return true;
        }

        const colors = this.colors.map(c => parseInt(c.substr(1), 16));
        this.time += deltaTime;
        let progress = this.time / (this.overrideTime ? this.animationTime : this.animationData.time);

        if (progress > 1) {
            progress = 1;
        }

        for (let i = 0; i < this.overrideColors.length; i++) {
            if (this.overrideColors[i]) {
                this.animationData.layers[i].color = colors[i];
            }
        }

        for (let j = 0; j < this.animationData.layers.length; j++) {
            const layer = this.animationData.layers[j];

            if (!layer.enabled || !layer.func) {
                continue;
            }

            for (let i = 0; i < this.ledArray.length; i++) {
                if (j === 0) {
                    this.ledArray[i] = multiplyColor(layer.color, layer.func(progress, i, this.state, this.nextState, j));
                }
                else {
                    // this.ledArray[i] = rgbaToColor(
                    //     blend.normal(
                    //         colorToRgba(this.ledArray[i]),
                    //         colorToRgba(multiplyColor(layer.color, layer.func(progress, i, this.state, this.nextState, j)))
                    //     )
                    // );

                    this.ledArray[i] = blendColors(this.ledArray[i], multiplyColor(layer.color, layer.func(progress, i, this.state, this.nextState, j)));
                }
            }
            console.log(colorToRgba(this.ledArray[0]));

            if (this.animationData.interpolateLastFirst) {
                if (progress > 0.5) {
                    for (let i = 0; i < this.animationData.interpolateLastFirst; i++) {
                        if (j === 0) {
                            this.ledArray[0 + i] = multiplyColor(layer.color, layer.func(progress, 12 + i, this.state, this.nextState, j));
                        }
                        else {
                            this.ledArray[0 + i] = blendColors(this.ledArray[0 + i], multiplyColor(layer.color, layer.func(progress, 12 + i, this.state, this.nextState, j)));
                        }
                    }
                }
                else {
                    for (let i = 0; i < this.animationData.interpolateLastFirst; i++) {
                        if (j === 0) {
                            this.ledArray[11 - i] = multiplyColor(layer.color, layer.func(progress, -1 - i, this.state, this.nextState, j));
                        }
                        else {
                            this.ledArray[11 - i] = blendColors(this.ledArray[11 - i], multiplyColor(layer.color, layer.func(progress, -1 - i, this.state, this.nextState, j)));
                        }
                    }
                }
            }
        }

        if (!sendLedsToStellaBIO(this.ledArray)) {
            throw new Error();
        }

        if (progress >= 1) {
            if (this.animationData.stateLoop) {
                this.time = 0;
            }

            this.state = this.nextState;
            this.nextState = this.queuedState;

            return true;
        }

        return false;
    }

    next() {
        this.queuedState = this.nextState + 1;
    }
}




export function loading(progress: number, diode: number, state: number, nextState: number): number {
    if (state === 7 && nextState === 7) {
        return 0.5;
    }

    // Final transition: light up all diodes
    if (state === 6 && nextState === 7) {
        if (diode % 2 === 0) {
            return 0.5;
        }

        return progress * 0.5;
    }

    // Take only every second diode for account for better effect (when diodes are to close then pulsing is less visible)
    if (diode % 2 === 1) {
        return 0;
    }

    const currentDiode = state * 2;

    // Pulse the current diode
    if (diode === currentDiode) {
        // When changing states do not pulse but smoothly light up
        if (nextState > state) {
            return progress * 0.5;
        }

        // Actually pulsing
        if (progress > 0.5) {
            return 1.0 - progress;
        }

        return progress;
    }

    // Diodes before are on and diodes after are off
    return diode < currentDiode ? 0.5 : 0;
}

function fixed0p5(x: number) {
    return 0.5;
}

function fixed1p0(x: number) {
    return 1.0;
}


function slope(x: number) {
    return x < 0 ? 0 : (x > 1 ? 0 : (x < 0.5 ? x * 2 : (1.0 - x) * 2));
}

function squaredSlope(x: number) {
    x = clamp(x, -0.5, 1.5);
    const m = x - 0.5;

    return -(m*m) + 1;
}

function clamp(x: number, min: number, max: number) {
    return Math.min(max, Math.max(min, x));
}

export function spin(progress: number, diode: number, state: number, nextState: number) {
    const spinDiode = progress * 12 + 0.5;

    return slope(clamp(spinDiode - diode, 0, 2) / 2);
}

export function smootherSpin(progress: number, diode: number, state: number, nextState: number) {
    const spinDiode = progress * 12 + 0.5;

    return squaredSlope(clamp(spinDiode - diode, -1, 3) / 2);
}

export function fill(progress: number, diode: number, state: number, nextState: number) {
    const spinDiode = progress * 14 + 0.5;

    const a = clamp(spinDiode - diode, 1, 3) / 2;

    if (a === 1) {
        return 1;
    }

    return squaredSlope(clamp(spinDiode - diode, 1, 3) / 2);
}

export function turnOn(progress: number, diode: number, state: number, nextState: number, layer: number) {

    const step = progress * 15;

    if (step < 7) {
        if (Math.floor(step) % 2 === 0) {
            return 1;
        }
    }

    // if (Math.floor(progress) % 2 === 0) {
    //     if (diode === 0 || diode === 6) {
    //         return slope(progress / 0.5);
    //     }
    // }
    // else {
    //     if (diode === 3 || diode === 9) {
    //         return slope((1.0 - progress) / 0.5);
    //     }
    // }

    return 0;
}

export function gradient(progress: number, diode: number, state: number, nextState: number, layer: number) {
    if (layer === 0) {
        return 1 - progress;
    }

    if (layer === 1) {
        return progress;
    }

    return 0;
}

export function gradient3Colors(progress: number, diode: number, state: number, nextState: number, layer: number) {
    if (layer === 0) {
        return slope(progress + 0.5);
    }

    if (layer === 1) {
        return slope(progress);
    }

    if (layer === 2) {
        return slope(progress - 0.5);
    }

    return 0;
}

export function flowing(progress: number, diode: number, state: number, nextState: number, layer: number) {

    if (diode >= 3 && diode <= 9) {
        const spinDiode = progress * 16 + 0.5 + 3 - 2;

        return squaredSlope(clamp(spinDiode - diode, -2, 6) / 4);
    }

    if (diode <= 3 || diode >= 9) {
        let spinDiode = 4 - progress * 16 + 0.5;
        spinDiode = diode <= 3 ? spinDiode : spinDiode + 11.5;

        return squaredSlope(clamp(diode - spinDiode, -2, 6) / 4);
    }


    return 0;
}

export function warning(progress: number, diode: number, state: number, nextState: number, layer: number) {
    const step = progress * 4;

    if (Math.floor(step) % 2 === 0) {
        return 1;
    }

    return 0;
}

export function slowBlink(progress: number, diode: number, state: number, nextState: number, layer: number) {
    // if (progress > 0.8) {
    //     return (1.0 - progress) / 0.2;
    // }

    // if (progress > 0.4) {
    //     return 1;
    // }

    if (progress > 0.80) {
        return 1;
    }

    return 0;
}

export function smootherSpinWithDot(progress: number, diode: number, state: number, nextState: number, layer: number) {
    if (layer === 1) {
        const spinDiode = progress * 12 + 0.5;

        return squaredSlope(clamp(spinDiode - diode, -1, 3) / 2);
    }
    // else if (diode === 3 || diode === 9) {
        // return slope(progress * 3)
        //     + slope(progress * 3 - 1)
        //     + slope(progress * 3 - 2)
            // + slope(progress * 5 - 3)
            // + slope(progress * 5 - 4)

        const step = progress * 4;

        if (Math.floor(step) % 2 === 0) {
            return 1;
        }
    // }

    return 0;
}

export function wifiConnected(progress: number, diode: number, state: number, nextState: number) {
    if (progress < 0.5) {
        const spinDiode = progress * 12 + 0.5;

        return squaredSlope(clamp(spinDiode - diode, -1, 3) / 2);
    }

    const spinDiode = progress * 12;

    return clamp(spinDiode - diode, -1, 3) / 2;
}

export function batteryLow(progress: number, diode: number, state: number, nextState: number, layer: number) {
    const step = progress * 4;

    if (Math.floor(step) % 2 === 0) {
        return 1;
    }

    return 0;
}
